import styled, { createGlobalStyle } from 'styled-components';

export const CloseButtonContainer = styled.div`
  top: ${props => props.theme.spacing(4)};
  right: ${props => props.theme.spacing(4)};
  position: absolute;
`;

export const ModalDialog = styled.div`
  background: ${props => props.theme.colors.background.lightest};
  width: 100%;
  padding: ${props => props.theme.spacing(6)};
  ${props => (props.mobileFullScreen ? 'height: 100vh;' : '')}
  @media ${props => props.theme.laptop} {
    width: unset;
    height: initial;
  }
`;

export const Container = styled.div`
  display: ${props => (props.shown ? `flex` : `none`)};
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding: ${props => props.theme.spacing(2)};
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`;

export const GlobalStyle = createGlobalStyle`
  .ModalOverlay {
    position:fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: ${props =>
      props.mobileFullScreen ? '0' : props.theme.spacing(3)};

    @media ${props => props.theme.tablet} {
      padding: ${props => props.theme.spacing(3)};
    }
  }

  .ModalContent {
    inset: unset;
    padding: 0;
    position: relative;
    border: 0;
    overflow: hidden;
    max-width: 350px;
    ${props => (props.mobileFullWidthOnly ? 'width: 100%;' : '')}
    ${props => (props.mobileFullScreen ? 'height: 100%;' : '')}
    ${props => (props.mobileFullScreen ? 'width: 100%;' : '')}
    border-radius: ${props => (props.mobileFullScreen ? '0' : '32px')};
    ${props =>
      props.mobileFullScreen
        ? ''
        : 'box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.08), 0px 0px 8px 2px rgba(0, 0, 0, 0.08);'}

    @media ${props => props.theme.tablet} {
      max-width: none;
      border-radius: 32px;
      box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.08),
        0px 0px 8px 2px rgba(0, 0, 0, 0.08);
      width: unset;
      height: unset;
      max-height: 100vh;
    }
  }
`;
